{
  "account": {
    "lt": "/paskyra/",
    "ru": "/paskyra/",
    "en": "/paskyra/"
  },
  "rules": {
    "lt": "/informacija-pirkejui/taisykles/",
    "ru": "/informacija-pirkejui/taisykles/",
    "en": "/informacija-pirkejui/taisykles/"
  },
  "contacts": {
    "lt": "/apie-mus/kontaktai/",
    "ru": "/apie-mus/kontaktai/",
    "en": "/apie-mus/kontaktai/"
  },
  "privacy": {
    "lt": "/informacija-pirkejui/privatumo-politika/",
    "ru": "/informacija-pirkejui/privatumo-politika/",
    "en": "/informacija-pirkejui/privatumo-politika/"
  }
}
